
<div class="container-fluid mt-3">
    <div class="row">
        <div class="col common-list-wrapper">
            <ul class="nav nav-pills flex-column">
                <li class="nav-item">
                    <a routerLink="create" routerLinkActive="active" class="nav-link" aria-current="page">
                        <i class="w-14 me-1 text-dark fa-solid fa-mobile"></i>
                        Criar/editar aplicativos
                    </a>
                </li>
                <li class="nav-item">
                    <a routerLink="list" routerLinkActive="active" class="nav-link" aria-current="page">
                        <i class="w-14 me-1 text-dark fa-solid fa-folder text-dark me-1"></i>
                        Listar aplicativos criados
                    </a>
                </li>               
                <li class="nav-item">
                    <a routerLink="pending" routerLinkActive="active" class="nav-link" aria-current="page">
                        <i class="w-14 me-1 text-dark fa-brands fa-hubspot"></i>
                        Listar aplicativos pendentes
                    </a>
                </li>               
            </ul>                  
        </div>        
        <div class="col">               
            <router-outlet></router-outlet>
        </div>
    </div>
</div>